import Axios from 'axios';

import PortainerError from './error';

/**
 * Thrown when the user dismisses a confirmation dialog - the request should be
 * silently abandoned with no error toast.
 *
 * Extends PortainerError so parseAxiosError returns it as-is without re-wrapping.
 */
export class SilentCancelError extends PortainerError {
  isSilentCancel = true;

  constructor() {
    super('');
  }
}

export function isSilentCancel(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  if (Axios.isCancel(error)) {
    return true;
  }

  if (
    'isSilentCancel' in error &&
    !!(error as SilentCancelError).isSilentCancel
  ) {
    return true;
  }

  // AngularJS services wrap errors in PortainerError — check the inner cause too
  if ('err' in error) {
    return isSilentCancel((error as { err: unknown }).err);
  }
  return false;
}
